'use client'

import GameDescriptionPageViaBuilder from 'src/pageContainers/GameDescriptionPageViaBuilder'

import type { GameProduct } from '@patrianna/shared-patrianna-types/store/GameModule'

const ROOM_DESCRIPTION_PAGE_MODEL = process.env.ROOM_DESCRIPTION

type Props = {
  pageProps: {
    page?: any
    gameProduct?: GameProduct
    defaultContent?: string
    meta?: any
  }
}

export default function BingoRoomDescription({ pageProps }: Props) {
  return <GameDescriptionPageViaBuilder pageProps={pageProps} pageModel={ROOM_DESCRIPTION_PAGE_MODEL} />
}
